import { AccountConfig } from '@/interfaces/AccountConfig';

interface IAccountConfigState {
  accountConfig: AccountConfig;
}

declare const window: { AccountConfig: AccountConfig };

const useAccountConfig = (): IAccountConfigState => {
    return {
        accountConfig: new AccountConfig(window.AccountConfig)
    };
};

export { useAccountConfig };
